export enum RouteType {
  Operaciones = '/Operaciones',
  User = '/user',
  Login = '/login',
  UserLogin = '/user-login',
  UserRegister = '/user-register',
  UserRestore = '/user-restore',
  UserForgot = '/user-forgot',
  Company = '/company',
  Empty = '/empty',
  Aviso = '/aviso'
}
export enum ViewType {
  Operaciones = 'Operaciones',
  Users = 'Users',
  Companies = 'Companies',
  Avisos = 'Avisos',
  Inspeciones = "Inspecciones",
  Help = 'Help',
  Empty = 'Empty'
}
export enum RolesType {
  Administrator = 'Administrator',
  Operations = 'Responsable',
  Consultant = 'Inspector'
}
